import * as Yup from "yup";
import { useMessageSource } from "react-message-source";
import { getCancelReasonOptionsData } from "./cancel-reason";

const MAX_CANCEL_REASON_TEXT_LENGTH = 400;

const useCancelReasonValidator = () => {
  const { getMessage } = useMessageSource();

  const { cancelReasonOptionOtherValue } =
    getCancelReasonOptionsData(getMessage);

  return Yup.object().shape({
    otherReason: Yup.string()
      .nullable()
      .when(["cancelReasonOption"], {
        is: (cancelOption: string) => {
          return cancelOption === cancelReasonOptionOtherValue;
        },
        then: () =>
          Yup.string()
            .nullable()
            .max(
              MAX_CANCEL_REASON_TEXT_LENGTH,
              getMessage(
                "Validation.message-maxLengthCharacters",
                MAX_CANCEL_REASON_TEXT_LENGTH,
              ),
            ),
      }),
  });
};

export default useCancelReasonValidator;
